import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import type { ContactFormPayload } from '../models/contact-form.model';

export type SubmitStatus = 'idle' | 'loading' | 'success' | 'error';

@Injectable({ providedIn: 'root' })
export class ContactService {
  private readonly http = inject(HttpClient);
  private readonly _status = signal<SubmitStatus>('idle');
  readonly status = this._status.asReadonly();

  submit(form: ContactFormPayload): void {
    this._status.set('loading');

    this.http.post<void>(`${environment.apiUrl}/api/contact`, form).subscribe({
      next: () => this._status.set('success'),
      error: () => this._status.set('error'),
    });
  }

  reset(): void {
    this._status.set('idle');
  }
}
